import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ScheduledEvent } from '../../../../../../../../../../../models/scheduled-event';
import { CallbackResult, CallbackResultStatus, dateStringFromISO8601 } from '../../../../../../../../../../../utils';
import { Customer, CustomerFilters } from '../../../../../../../../../../../models/customer';
import { ListResponse } from '../../../../../../../../../../../models/list-response';
import { CustomerService } from '../../../../../../../../../../../services/customer/customer.service';
import { OrganizationConfigService } from '../../../../../../../../../../../services/organization-config/organization-config.service';
import { AccountService } from '../../../../../../../../../../../services/account/account.service';
import { ScheduledEventService } from '../../../../../../../../../../../services/scheduled-event/scheduled-event.service';
import { openClimberAppInNewTabAsCustomer, openClimberAppInNewTabAsStaff } from '../../../../../../../../../../../utils-models';
import { EventNote } from '../../../../../../../../../../../models/event';
import { EventService } from '../../../../../../../../../../../services/event/event.service';


@Component({
  selector: 'app-add-to-event-waitlist-modal',
  templateUrl: './edit-event-note-modal.component.html',
  styleUrls: ['./edit-event-note-modal.component.css']
})
export class EditEventNoteModalComponent {

  @Input() note: EventNote;
  @Input() addedCallback: (result: CallbackResult) => undefined;

  public inEditMode = false;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private eventService: EventService
  ) {}

  public handleRemove() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.eventService
      .deleteEventNote(this.note)
      .then(updatedNote => {
        this.addedCallback({
          text: 'Note removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this note.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.eventService
      .updateEventNote(this.note)
      .then(updatedNote => {
        this.addedCallback({
          text: 'Note updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this note.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
